const u = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMG = {
  hero: "/assets/hero-sopaj.webp",
  impresa: u("1600607687939-ce8a6c25118c"),
  blueprint: u("1542621334-a254cf47733d"),
  cantiere: u("1541888946425-d81bb19240f5"),
  workers: u("1504307651254-35680f356dfd"),
  prima: "/assets/prima-cantiere.webp",
  dopo: "/assets/dopo-cantiere.webp",
  bagno: u("1620626011761-996317b8d101"),
  cucina: u("1556909114-f6e7ad7d3136"),
  pavimenti: u("1600607687920-4e2a09cf159d"),
  esterni: u("1605146769289-440113cc3d00"),
  manutenzione: u("1581578731548-c64695cc6952"),
  tinteggiatura: u("1589939705384-5185137a7f0f"),
  completa: u("1600585154340-be6161a56a0c"),
  villa: u("1600596542815-ffad4c1539a9"),
  appartamento: u("1522708323590-d24dbb6b0267"),
  architettura: u("1503387762-592deb58ef4e"),
};

export const PHONE_DISPLAY = "328 702 5632";
export const PHONE_TEL = "tel:+393287025632";
export const WHATSAPP_URL =
  "https://wa.me/393287025632?text=Buongiorno%2C%20vorrei%20richiedere%20informazioni%20per%20una%20ristrutturazione.";
export const EMAIL = "sopajdemir@live.it";
export const ADDRESS = "Via Monsignor Boffa, 5 — 23895 Nibionno (LC)";
export const PIVA = "04085990960";

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/impresa", label: "L'Impresa" },
  { to: "/servizi", label: "Servizi" },
  { to: "/chiavi-in-mano", label: "Chiavi in Mano" },
  { to: "/lavori", label: "Lavori" },
  { to: "/contatti", label: "Contatti" },
];

export const SERVICES = [
  {
    slug: "ristrutturazioni-complete",
    title: "Ristrutturazioni complete",
    text: "Ristrutturazioni di appartamenti, ville e abitazioni con coordinamento delle diverse fasi del cantiere.",
    img: IMG.completa,
  },
  {
    slug: "opere-murarie",
    title: "Opere murarie",
    text: "Demolizioni, costruzione di tramezzi, modifiche interne, aperture e opere edili.",
    img: IMG.cantiere,
  },
  {
    slug: "rifacimento-bagni",
    title: "Rifacimento bagni",
    text: "Ristrutturazione completa del bagno, dalle demolizioni fino alle finiture.",
    img: IMG.bagno,
  },
  {
    slug: "rifacimento-cucine",
    title: "Rifacimento cucine",
    text: "Interventi murari e predisposizioni necessarie alla realizzazione della nuova cucina.",
    img: IMG.cucina,
  },
  {
    slug: "pavimenti-rivestimenti",
    title: "Pavimenti e rivestimenti",
    text: "Preparazione dei fondi e posa di pavimenti e rivestimenti.",
    img: IMG.pavimenti,
  },
  {
    slug: "cartongesso-controsoffitti",
    title: "Cartongesso e controsoffitti",
    text: "Pareti, velette, controsoffitti e soluzioni per ridefinire gli ambienti.",
    img: IMG.workers,
  },
  {
    slug: "tinteggiature-finiture",
    title: "Tinteggiature e finiture",
    text: "Completamento degli ambienti e attenzione alle finiture.",
    img: IMG.tinteggiatura,
  },
  {
    slug: "esterni",
    title: "Esterni",
    text: "Interventi su facciate, balconi, terrazzi e parti esterne.",
    img: IMG.esterni,
  },
  {
    slug: "manutenzioni-edili",
    title: "Manutenzioni edili",
    text: "Interventi di manutenzione ordinaria e straordinaria.",
    img: IMG.manutenzione,
  },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Sopralluogo" },
  { n: "02", title: "Valutazione dell'intervento" },
  { n: "03", title: "Preventivo" },
  { n: "04", title: "Organizzazione del cantiere" },
  { n: "05", title: "Esecuzione dei lavori" },
  { n: "06", title: "Finiture" },
  { n: "07", title: "Consegna" },
];

export const REASONS = [
  { n: "01", title: "Esperienza concreta", text: "Competenza maturata attraverso anni di lavoro sul campo e gestione diretta dei cantieri." },
  { n: "02", title: "Rapporto diretto", text: "Un punto di riferimento durante l'intero lavoro." },
  { n: "03", title: "Ristrutturazioni complete", text: "Possibilità di affidare l'intervento a un unico interlocutore." },
  { n: "04", title: "Preventivi chiari", text: "Descrizione trasparente delle lavorazioni previste." },
  { n: "05", title: "Cura delle lavorazioni", text: "Attenzione all'esecuzione e alle finiture." },
  { n: "06", title: "Disponibilità senza confini rigidi", text: "La sede è a Nibionno, ma ogni progetto viene valutato in base alle sue caratteristiche, anche al di fuori della zona locale." },
];

export const PORTFOLIO_CATEGORIES = [
  "Ristrutturazioni complete",
  "Appartamenti",
  "Ville",
  "Bagni",
  "Cucine",
  "Pavimenti",
  "Opere murarie",
  "Cartongessi",
  "Esterni",
];

export const PORTFOLIO = [
  { id: 1, category: "Ristrutturazioni complete", title: "Ristrutturazione completa", img: IMG.completa },
  { id: 2, category: "Appartamenti", title: "Ristrutturazione appartamento", img: IMG.appartamento },
  { id: 3, category: "Ville", title: "Intervento su villa", img: IMG.villa },
  { id: 4, category: "Bagni", title: "Rifacimento bagno", img: IMG.bagno },
  { id: 5, category: "Cucine", title: "Rifacimento cucina", img: IMG.cucina },
  { id: 6, category: "Pavimenti", title: "Posa pavimenti e rivestimenti", img: IMG.pavimenti },
  { id: 7, category: "Opere murarie", title: "Demolizioni e tramezzi", img: IMG.cantiere },
  { id: 8, category: "Cartongessi", title: "Controsoffitti e velette", img: IMG.workers },
  { id: 9, category: "Esterni", title: "Intervento su facciata", img: IMG.esterni },
];

export const COMUNI = [
  "Nibionno", "Oggiono", "Costa Masnaga", "Molteno", "Brivio", "Merate",
  "Barzago", "Dolzago", "Sirone", "Lecco", "Monza", "Como",
];

export const TIPOLOGIE = [
  "Ristrutturazione completa",
  "Rifacimento bagno",
  "Rifacimento cucina",
  "Opere murarie",
  "Pavimenti e rivestimenti",
  "Cartongesso e controsoffitti",
  "Tinteggiature e finiture",
  "Esterni",
  "Manutenzione edile",
  "Altro",
];
